// @ts-nocheck
import { SignedIn, SignedOut, RedirectToSignIn } from '@/auth/clerkShim';

export default function ProtectedRoute({ children }: { children: React.ReactNode }) {
  return (
    <>
      <SignedIn>{children}</SignedIn>
      <SignedOut>
        <RedirectToSignIn />
      </SignedOut>
    </>
  );
}